var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0865 9.26292V10.9352C12.0871 11.0905 12.0553 11.2442 11.9931 11.3864C11.9309 11.5287 11.8397 11.6564 11.7253 11.7613C11.6109 11.8663 11.4759 11.9462 11.3288 11.9959C11.1817 12.0456 11.0259 12.0641 10.8713 12.0501C9.15593 11.8638 7.50822 11.2776 6.06054 10.3388C4.71366 9.48292 3.57174 8.341 2.71588 6.99412C1.77378 5.53986 1.1875 3.88414 1.00452 2.16108C0.990594 2.00693 1.00891 1.85157 1.05832 1.70488C1.10772 1.5582 1.18713 1.42341 1.29148 1.3091C1.39583 1.19478 1.52284 1.10345 1.66442 1.04091C1.806 0.978373 1.95906 0.946001 2.11384 0.945855H3.78617C4.0567 0.943192 4.31897 1.03899 4.52409 1.2154C4.72921 1.3918 4.86319 1.63678 4.90106 1.90466C4.97164 2.43984 5.10255 2.96532 5.29127 3.47108C5.36627 3.6706 5.3825 3.88744 5.33804 4.0959C5.29358 4.30437 5.19029 4.49572 5.04042 4.64728L4.33246 5.35524C5.12602 6.75082 6.28154 7.90635 7.67713 8.6999L8.38508 7.99195C8.53664 7.84207 8.72799 7.73878 8.93646 7.69432C9.14492 7.64986 9.36177 7.6661 9.56129 7.7411C10.067 7.92982 10.5925 8.06072 11.1277 8.13131C11.3985 8.16951 11.6458 8.3059 11.8226 8.51455C11.9994 8.72319 12.0933 8.98953 12.0865 9.26292Z",
    stroke: "#454D66",
    strokeOpacity: 0.7,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.0bee354522dbc39b864eb51992d72e4b.svg";
export { ForwardRef as ReactComponent };